(function () {
    "use strict";

    angular
        .module("app")
        .directive("htsDutySearchHelp", ["SearchFactory", htsDutySearchHelp]);

    function htsDutySearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (!scope.originCountry || scope.originCountry.length === 0 || !scope.destCountry || scope.destCountry.length === 0)
                        return;

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.htsDutyKey = "";
                        scope.htsDutyStawn = "";
                        scope.duty = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.htsDutyStawn === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.htsDutySearch(scope.originCountry, scope.destCountry, function (htsDuty) {
                        scope.htsDutyKey = htsDuty ? htsDuty.HTSKey : "";
                        scope.htsDutyStawn = htsDuty ? htsDuty.HTSStawn : "";
                        scope.duty = htsDuty ? htsDuty.Duty : "";
                        scope.displayValue = scope.htsDutyStawn;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.$watch("htsDutyStawn", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.htsDutyStawn;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { htsDutyKey: "=", htsDutyStawn: "=", duty: "=", destCountry: "@", originCountry: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

